import React from 'react';
import { HeartCrackIcon, MoonIcon, AlertTriangleIcon, BatteryLowIcon } from 'lucide-react';
const pains = [{
  icon: AlertTriangleIcon,
  title: 'Improvisás cada día',
  desc: 'Buscás en internet qué hacer ante cada situación nueva, sin una guía clara que seguir.'
}, {
  icon: HeartCrackIcon,
  title: 'Miedo a equivocarte',
  desc: 'Con la medicación, la alimentación o al moverlo. El error no es una opción y eso pesa.'
}, {
  icon: BatteryLowIcon,
  title: 'Agotamiento total',
  desc: 'El cansancio físico y mental te pasa factura, y sentís que estás solo en esto.'
}, {
  icon: MoonIcon,
  title: 'Noches sin descanso',
  desc: 'Ver cómo pierde autonomía sin saber cómo ayudarlo te quita el sueño y la tranquilidad.'
}];
export function ProblemSection() {
  return <section className="w-full bg-navy py-20 px-5 sm:px-8 lg:px-12 overflow-hidden pt-[30px] pb-[30px]" data-id="element-121">
      <div className="max-w-6xl mx-auto" data-id="element-122">
        <div className="text-center mb-14" data-id="element-123">
          <span className="inline-block tracking-[0.2em] text-xs md:text-sm font-semibold uppercase mb-4 text-[#FF811B]" data-id="element-124">
            El día a día de un cuidador
          </span>
          <h2 className="font-serif text-white text-3xl md:text-5xl font-bold leading-tight max-w-4xl mx-auto" data-id="element-125">
            ¿Te sentís <span className="text-[#FF811B]" data-id="element-126">abrumado</span> por no
            saber si estás cuidando bien a tu ser querido?
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center" data-id="element-127">
          {/* Visual */}

          {/* Pain cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-128">
            {pains.map((pain, idx) => {
            const Icon = pain.icon;
            return <div key={idx} className="bg-navy-band/60 border border-white/10 rounded-2xl p-6 hover:border-coral/50 transition-colors" data-id="element-129">
                  <div className="w-12 h-12 rounded-xl bg-coral/15 flex items-center justify-center mb-4" data-id="element-130">
                    <Icon className="w-6 h-6 text-coral" data-id="element-131" />
                  </div>
                  <h3 className="text-white font-bold text-lg mb-2" data-id="element-132">
                    {pain.title}
                  </h3>
                  <p className="text-gray-300/80 text-sm leading-relaxed" data-id="element-133">
                    {pain.desc}
                  </p>
                </div>;
          })}
          </div>
        </div>

        {/* Reassurance banner */}
        <div className="mt-14 bg-navy-deep border border-coral/30 rounded-3xl p-8 md:p-10 text-center max-w-4xl mx-auto shadow-panel" data-id="element-134">
          <h3 className="text-white text-2xl md:text-3xl font-bold mb-4" data-id="element-135">
            No es tu culpa.{' '}
            <span className="text-[#FFFFFF]" data-id="element-136">
              Nadie nos enseña a ser cuidadores.
            </span>
          </h3>
          <p className="text-lg leading-relaxed font-[800] text-[#FF811B]" data-id="element-137">
            Pero seguir improvisando pone en riesgo la salud de tu ser querido y
            tu propia paz mental. Necesitás un sistema claro, paso a paso,
            diseñado por profesionales.
          </p>
        </div>
      </div>
    </section>;
}